import type { SpeckleMaterial } from "@/types/Views/MappingWizard/SpeckleMaterial";

// The layers a colour key reads: a type's included children, or the type itself when it has none.
export function includedLayers(type: SpeckleMaterial): SpeckleMaterial[] {
  const children = (type.children ?? []) as SpeckleMaterial[];
  return children.length ? children.filter((layer) => layer?.includeMapping !== false) : [type];
}

// "2 of 3 layers <wording>"; under Not mapped it counts the mapped layers, as the mapping rows do.
export function layerCountSubLine(
  type: SpeckleMaterial,
  category: string,
  classifyLayer: (layer: SpeckleMaterial) => string | null,
  wording: Record<string, string>
): string {
  const layers = includedLayers(type);
  const matches =
    category === "unmapped"
      ? layers.filter((layer) => layer.mapping != null).length
      : layers.filter((layer) => classifyLayer(layer) === category).length;
  return `${matches} of ${layers.length} ${layers.length === 1 ? "layer" : "layers"} ${wording[category] ?? category}`;
}
